import jwt from 'jsonwebtoken'
import streamDataApi from '@/apis/streamData'

const setToken = ({ commit }, token) => {
  try {
    window.$cookies.set('_session', token, '1D')
    const customer = jwt.verify(token, process.env.VUE_APP_SIGN_KEY)
    commit('SET_CUSTOMER', customer)
    return { headerUrl: customer.menuData }
  } catch (error) {
    throw new Error(error)
  }
}

const sendForm = async ({ commit, state }, message) => {
  try {
    const payLoad = {
      'email': state.email,
      'affiliateid': state.affiliateId,
      'customerid': state.customerId,
      'action': 'click',
      'event': 'feedback',
      'target': {
        'type': 'feedback-submit',
        'value': {
          'content': message
        }
      }
    }

    let status = {
      'message': '',
      'messageSent': true,
      'messageVariant': ''
    }

    const { data: response } = await streamDataApi.sendForm(payLoad)
    if (response.statuscode === '200') {
      status.message = 'Your Message has been sent successfully'
      status.messageVariant = 'success'
    } else {
      status.message = 'There was an error submitting your message. Please try again later.'
      status.messageVariant = 'danger'
    }
    commit('SET_MESSAGE', status)
    if(status.messageSent) scrollMessageIntoView()
  } catch (error) {
    throw new Error(error)
  }
}

const showMessage = ({ commit }, status) => {
  commit('SET_MESSAGE', status)
  if(status.messageSent) scrollMessageIntoView()
}

const scrollMessageIntoView = () => {
  document.getElementById("notification-container").scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
}

export default {
  setToken,
  sendForm,
  showMessage
}
